import { render, staticRenderFns } from "./reportInterpretation.vue?vue&type=template&id=36e21160&scoped=true"
import script from "./reportInterpretation.vue?vue&type=script&lang=js"
export * from "./reportInterpretation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e21160",
  null
  
)

export default component.exports